/* eslint-disable */

import { memo, useEffect, useState } from "react";
// styles
// import "./style.scss";

import { Button, Divider, Select, Skeleton, Space, Tag } from "antd";

const SelectCustom = ({
  // default props
  className,
  children,
  item,
  listOptions,
  renderExtraSelect = false,
  mode,
  allowClear,
  disabled,
  refForm,
  showSearch,
  filterOption,
  filterSort,
  optionFilterProp,
  ready,
  ...rest
}) => {
  if (ready === false) {
    return <Skeleton />;
  }
  const [selectedItems, setSelectedItems] = useState(listOptions.map((e) => e.key));
  const [selectedItem, setSelectedItem] = useState(null);

  // useEffect(() => {
  //   setSelectedItems(listOptions.map((e) => e.key));
  // }, [listOptions]);

  const filteredOptions = listOptions.filter((o) => !selectedItems.includes(o.key));

  useEffect(() => {
    refForm?.current?.setFieldsValue({ [item.name]: selectedItems });
  }, [selectedItems]);

  const tagRender = (props) => {
    const { value, closable, onClose } = props;
    const label = listOptions.find((i) => i.key === value)?.label;

    return (
      <Tag
        closable={closable}
        onClose={onClose}
        style={{
          fontSize: 14,
          border: 0,
          borderRadius: "0.375rem",
          padding: "0.25rem 0.5rem",
          fontWeight: 500,
          backgroundColor: "#f5f5f5",
        }}
      >
        {label}
      </Tag>
    );
  };

  const selectAll = () => {
    setSelectedItems(listOptions.map((e) => e.key));
  };

  const invert = () => {
    let newMap = [];

    newMap = listOptions.filter((o) => !selectedItems.includes(o.key));
    setSelectedItems(newMap.map((e) => e.key));
  };

  const deselectAll = () => {
    setSelectedItems([]);
  };

  return (
    <Select
      optionFilterProp={optionFilterProp}
      filterOption={filterOption}
      filterSort={filterSort}
      mode={mode}
      allowClear={allowClear}
      disabled={disabled}
      showSearch={showSearch}
      value={mode === "multiple" ? selectedItems : selectedItem}
      defaultValue={mode === "multiple" ? selectedItems : selectedItem}
      onDeselect={(e) => {
        setSelectedItems(selectedItems.filter((o) => o !== e));
      }}
      tagRender={tagRender}
      onSelect={(newItem) => {
        setSelectedItems([...selectedItems, newItem]);
      }}
      dropdownRender={(menu) =>
        renderExtraSelect ? (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />

            <Space style={{ padding: "0 8px 4px" }}>
              <Button type="primary" onClick={selectAll}>
                Tout sélectionner
              </Button>
              <Button type="primary" onClick={invert}>
                Inverser
              </Button>
              <Button type="primary" onClick={deselectAll}>
                Tout déselectionner
              </Button>
            </Space>
          </>
        ) : (
          menu
        )
      }
    >
      {listOptions.map((option, i) => (
        <Select.Option
          {...option}
          key={option?.key || option?.value}
          value={option?.value || option?.key}
          color={option?.color}
        >
          {option?.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default memo(SelectCustom);
